import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { SortState } from '@/hooks/use-url-state';
import { fetch_review_counts, fetch_review_list, hide_review, unhide_review } from './api';
import type { AdminReviewFilters } from './types';

const LIST_KEY = 'admin-review-list';
const COUNTS_KEY = 'admin-review-counts';

export function use_review_list(filters: AdminReviewFilters, sort?: SortState) {
  return useQuery({
    queryKey: [LIST_KEY, filters, sort],
    queryFn: () => fetch_review_list(filters, sort),
    placeholderData: (prev) => prev,
  });
}

export function use_review_counts() {
  return useQuery({ queryKey: [COUNTS_KEY], queryFn: fetch_review_counts });
}

export function use_hide_review() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => hide_review(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [LIST_KEY] });
      qc.invalidateQueries({ queryKey: [COUNTS_KEY] });
    },
  });
}

export function use_unhide_review() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => unhide_review(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [LIST_KEY] });
      qc.invalidateQueries({ queryKey: [COUNTS_KEY] });
    },
  });
}
